import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  value?: string | number;
  align?: "left" | "right";
}

export const CellDateFormatter = <TData,>(props: TableCellProps<TData>) => {
  return (
    <div
      className={`font-normal text-xs
       px-4 py-2.5 h-full bg-inherit text-v2-primary flex items-center gap-3 font-mono ${
         props.align === "left" ? "justify-start" : "justify-end"
       }`}
      title={String(props.cell.getValue())}
    >
      {props.value ? props.value : String(props.cell.getValue())}
    </div>
  );
};
